let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3SWvG")).then(() => parcelRequire('bxbXk'));